import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import ProjectList from './project-item'

class ClazzCourseList extends React.PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        const { data, share, allowDelete, top, itemNum, cardType, userShow, onClose, userInfo } = this.props;
        let linkUrl, imgUrl, itemName;
        let list = [];

        data.map(item => {
            if (cardType === 'course') {
                linkUrl = `/course?clazz_id=${item.pivot.clazz_id}&id=${item.id}`;
                imgUrl = window.config.staticURL + '/cover/course/' + item.id + '.png';
            } else if (cardType === 'courseEdit') {
                linkUrl = `/teacher/course?clazz_id=${item.pivot.clazz_id}&id=${item.id}`;
                imgUrl = window.config.staticURL + '/cover/course/' + item.id + '.png';
            }
            else {
                linkUrl = `/project/${item.id}?type=share`;
                imgUrl = window.config.staticURL + '/thumb/' + (item.id || 'default') + '.png';
            }
            itemName = item.title ? item.title : item.name
            const obj = {
                id: item.id,
                name: itemName,
                linkUrl: linkUrl,
                imgUrl: imgUrl,
                dataObj: item,
                rank:item.rank
            }
            list.push(obj)
        })

        return (
            <React.Fragment>
                <ProjectList
                    allowDelete={allowDelete}
                    data={list}
                    share={share}
                    itemNum={itemNum}
                    cardType={cardType}
                    top={top}
                    userShow={userShow}
                    onClose={onClose}
                    userInfo={userInfo}
                />
            </React.Fragment>
        )
    }
}

ClazzCourseList.propTypes = {
    allowDelete: PropTypes.bool,
    top: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.object),
    share: PropTypes.bool,
    cardType: PropTypes.string,
    itemNum: PropTypes.number,
    onClose: PropTypes.func,
    userInfo: PropTypes.object
}

export default withRouter(ClazzCourseList)
